import React, { useEffect } from "react";
import SectionOne from "../component/homecomponent/SectionOne";
import SectionThree from "../component/homecomponent/SectionThree";
import SectionTwo from "../component/homecomponent/SectionTwo";
import HomeBanner from "../component/homecomponent/HomeBanner";
import SectionFour from "../component/homecomponent/SectionFour";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const message = params.get("message");

    if (status && message) {
      const decodedMessage = decodeURIComponent(message);

      if (status === "true") {
        toast.success(decodedMessage || "Payment successful!");
      } else {
        toast.error(decodedMessage || "Payment failed!");
      }

      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [location]);

  return (
    <>
      <HomeBanner />
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour />
    </>
  );
};

export default Home;
